import { useContext } from 'react';
import LanguageContext from '../../../contexts/languageContext';
import MessagesContext from '../../../contexts/messagesContext';

const useConfig = ({ isFormStatistics }) => {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);

    const footer = (tooltipItems) => {
        let sum = 0;
        let date;

        tooltipItems.forEach(function (tooltipItem) {
            sum += tooltipItem.parsed.y;
            date = tooltipItem.label;
        });
        return (
            `${isFormStatistics ? messages.newForm : messages.newPatient} ` +
            ' ' +
            sum +
            '\n' +
            date
        );
    };

    const options = {
        responsive: true,
        borderSkipped: 'bottom',
        maintainAspectRatio: false,
        scales: {
            x: {
                ticks: {
                    font: {
                        size: 12,
                        family: 'mainFont'
                    },
                    color: '#989ea3'
                },
                grid: {
                    drawOnChartArea: false,
                    display: false,
                    border: '#fff',
                    backgroundColor: '#fff'
                }
            },
            y: {
                beginAtZero: true,

                ticks: {
                    count: 6,
                    padding: 10
                },
                grid: {
                    borderDash: [8, 4],
                    tickBorderDashOffset: 10,
                    tickColor: 'white',
                    drawTicks: false,
                    drawBorder: false,

                    color: function (context) {
                        if (context.tick.value === 0) {
                            return 'rgba(0, 0, 0, 0)';
                        }
                        return '#ced2d6';
                    }
                }
            }
        },

        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false
            },
            tooltip: {
                yAlign: 'bottom',
                footerColor: '#416ce1',
                backgroundColor: '#ebf0ff',
                footerFont: { family: 'mainFont' },
                footerAlign: lang === 'fa' ? 'right' : 'left',
                callbacks: {
                    footer: footer,
                    label: function () {
                        let label = '';
                        return label;
                    },
                    title: function () {
                        let label = '';
                        return label;
                    }
                }
            }
        }
    };
    return { options };
};

export default useConfig;
